import React, { useState, useEffect } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../Styles/CheckboxList.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../../Components/BasicElements/BackModal';
import ConfirmModal from '../../../Components/BasicElements/ConfirmModal';
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const InsertRole = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
	const [showBackModal, setShowBackModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [hasChanges, setHasChanges] = useState(false);
	const [inputError, setInputError] = useState([]);
	const [addData, setAddData] = useState([]);
	const [isActive, setIsActive] = useState(true);

	//#region save button Function Onlick
	function RegisterNewRole() {
		let functionName = "";
		try {
			functionName = props.page + RegisterNewRole.name;
			setLoading(true);
			setLoadingText("Registering New Role, PLease wait....")
			const data = {
				ROLE_ID: addData.ROLE_ID,
				ROLE_NAME: addData.ROLE_NAME.trim(),
				REMARK: addData.REMARK,
				ACTIVE_FLAG: isActive ? "Y" : "N",
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.post("api/role/RegisterRole", data, { timeout: 1000000 })
				.then((response) => {
					if (response.data.DUPLICATE_ROLE_NAME === true) {
						toast.error("Role Name " + response.data.ROLE_NAME + " already exist.");
					} else {
						toast.success("Role is successfully inserted.");
						props.onReload();
					}
				})
				.catch((err) => {
					toast.error("Failed to insert role. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
		} catch (err) {
			toast.error("Failed to insert role. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (id !== "REMARK") {
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: `${name} could not be empty.`,
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: "",
				}));
			}
		} else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setAddData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
	};

	//#region Event Handle
	const hideModal = () => {
    setAddData([]);
    setInputError([]);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		var flag = true;
		if (addData.ROLE_NAME === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				ROLE_NAME: (" Role Name could not be empty."),
			}));
		}
		if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			setShowConfirmModal(true);
		}
  };

  const handleConfirmModal = () => {
    RegisterNewRole();
    setShowConfirmModal(false); // Hide confirm modal
		hideModal();
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };

	return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered size="mg">
				<Modal.Header>
					<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
						<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Create</Modal.Title>
					</div>
				</Modal.Header>

				<Modal.Body>
					<Comp.Input
						id="ROLE_NAME"
						label="Role*"
						name="Role Name"
						type="text"
						className="form-control"
						errorMessage={inputError.ROLE_NAME}
						value={addData.ROLE_NAME}
						onChange={inputRequiredHandler}
					/>

					<Comp.Input
						id="REMARK"
						label="Remark"
						name="Remark"
						type="text"
						className="form-control"
						errorMessage={inputError.REMARK}
						value={addData.REMARK}
						onChange={inputRequiredHandler}
					/>
				</Modal.Body>

				<Modal.Footer>
					<div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
						</Comp.Button>
						
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

			{/* Success Message Modal */}
			<BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
				prop="Confirm Navigation"
			>
				Are you sure you want to go back? Your changes may be lost.
			</BackModal>
			
			<ConfirmModal
          show={showConfirmModal}
          onHide={handleConfirmModalClose}
          onConfirm={handleConfirmModal}
          prop="Confirm to save"
      >
        Are you sure you want to create new role?
      </ConfirmModal>

			{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
		</>
	);
};

export default InsertRole;